import {
  BadgeCheck,
  CalendarClock,
  Fuel as FuelIcon,
  GraduationCap,
  Hash,
  HeartHandshake,
  House,
  ListChecks,
  MoonStar,
  Smartphone,
  Ticket,
  TrendingUp,
  Zap,
} from "lucide-react";
import Advert from "../components/Advert";
import AirlineTicketTransfer from "../components/AirlineTicketTransfer";
import Emyc from "../components/Emyc";
import Derash from "../components/Derash";
import DerashBillers from "../components/DerashBillers";
import Event from "../components/Event";
import EventList from "../components/EventList";
import Fuel from "../components/Fuel";
import Flyzagol from "../components/Flyzagol";
import Hajj from "../components/Hajj";
import IPSPayment from "../components/IPSPayment";
import Mpesa from "../components/Mpesa";
import Rent from "../components/Rent";
import SchedulePayment from "../components/SchedulePayment";
import School from "../components/School";
import SharePurchase from "../components/SharePurchase";
import Transfer from "../components/Transfer";
import Ussd from "../components/Ussd";
import UtilityList from "../components/UtilityList";
import UtilityTransfer from "../components/UtilityTransfer";

export const serviceRoutes = [
  {
    id: "transfer",
    path: "/transfer",
    component: Transfer,
    icon: HeartHandshake,
    labelIndex: 0,
    workflowType: "standard-payment",
    showInMenu: true,
  },
  {
    id: "utilities",
    path: "/utilities",
    component: UtilityList,
    icon: Zap,
    labelIndex: 1,
    workflowType: "service-catalog",
    showInMenu: true,
  },
  {
    id: "schedule-payment",
    path: "/schedule-payment",
    component: SchedulePayment,
    icon: CalendarClock,
    labelIndex: 2,
    workflowType: "complex-payment",
    showInMenu: true,
  },
  {
    id: "school",
    path: "/school",
    component: School,
    icon: GraduationCap,
    labelIndex: 3,
    workflowType: "complex-payment",
    showInMenu: true,
  },
  {
    id: "fuel",
    path: "/fuel",
    component: Fuel,
    icon: FuelIcon,
    labelIndex: 5,
    workflowType: "reference-payment",
    showInMenu: true,
  },
  {
    id: "mpesa",
    path: "/mpesa",
    component: Mpesa,
    icon: Smartphone,
    labelIndex: 6,
    workflowType: "placeholder",
    showInMenu: true,
  },
  {
    id: "events",
    path: "/event",
    component: EventList,
    icon: Ticket,
    labelIndex: 7,
    workflowType: "complex-payment",
    showInMenu: true,
  },
  {
    id: "share-purchase",
    path: "/purchaseShare",
    component: SharePurchase,
    icon: TrendingUp,
    labelIndex: 8,
    workflowType: "complex-payment",
    showInMenu: true,
  },
  {
    id: "rent",
    path: "/rental",
    component: Rent,
    icon: House,
    labelIndex: 9,
    workflowType: "complex-payment",
    showInMenu: true,
  },
  {
    id: "hajj",
    path: "/hajj",
    component: Hajj,
    icon: MoonStar,
    labelIndex: 10,
    workflowType: "reference-payment",
    showInMenu: true,
  },
  {
    id: "ussd",
    path: "/ussd",
    component: Ussd,
    icon: Hash,
    labelIndex: 11,
    workflowType: "placeholder",
    showInMenu: true,
  },
  {
    id: "emyc",
    path: "/emyc",
    component: Emyc,
    icon: BadgeCheck,
    labelIndex: 12,
    workflowType: "reference-payment",
    showInMenu: true,
  },
  {
    id: "derash",
    path: "/derash",
    component: DerashBillers,
    icon: ListChecks,
    labelIndex: 13,
    workflowType: "biller-payment",
    showInMenu: true,
  },
  {
    id: "utility-transfer",
    path: "/transferUtility/:name/:fields",
    component: UtilityTransfer,
    workflowType: "dynamic-payment",
  },
  {
    id: "event-detail",
    path: "/eventDetail",
    component: Event,
    workflowType: "complex-payment",
  },
  {
    id: "airline",
    path: "/airline",
    component: AirlineTicketTransfer,
    workflowType: "reference-payment",
  },
  {
    id: "flyzagol",
    path: "/flyzagol",
    component: Flyzagol,
    workflowType: "reference-payment",
  },
  {
    id: "derash-payment",
    path: "/derash/payment",
    component: Derash,
    workflowType: "reference-payment",
  },
  {
    id: "ips",
    path: "/ips",
    component: IPSPayment,
    workflowType: "complex-payment",
  },
  {
    id: "advert",
    path: "/ad",
    component: Advert,
    workflowType: "content",
  },
];

export const menuServices = serviceRoutes.filter(
  (service) => service.showInMenu
);
